import http from '../../utils/http'; //封装的拦截器及错误处理的axios
import Qs from 'qs';

const memberApi = {
  submitOfferOnline(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      method: 'post',
      url: 'declare/offeronline/submit.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  downloadOfferOnline(params){
    return http({ method: 'get', url: 'product/offeronline/download.jspx', params: params })
  },
  getDeclareResult(params){
    return http({ method: 'get', url: 'declare/result/get.jspx', params: params })
  },
  listDeclareResult(params){
    return http({ method: 'get', url: '/declare/result/list.jspx', params: params })
  },
  productPage(params){
    // const arr = [];
    // Object.entries(params).forEach((item) => {
    //   arr.push(`${item[0]}=${encodeURIComponent(item[1])}`)
    // })
    // return http({ method: 'get', url: `/product/v_list.jspx?${arr.join('&')}` })
    return http({ method: 'get', url: '/product/v_list.jspx', params: params })
  },
  productDeclarePage(params){
    return http({ method: 'get', url: '/product/declare/page.jspx', params: params })
  },
  listUploadDownload(params){
    return http({ method: 'get', url: '/product/winprice/uploaddownload/page.jspx', params: params })
  },
  getByAssess(params) {
    return http({
      method: 'post',
      url: '/product/get.jspx',
      params: params
    })
  },
  getApplyCount(params) {
    return http({
      method: 'post',
      url: '/product/declare/applyCount.jspx',
      params: params
    })
  },
  getApplyList(params) {
    return http({
      method: 'post',
      url: '/product/declare/list.jspx',
      params: params
    })
  },
  getBeWinList(params) {
    return http({
      method: 'post',
      url: '/product/declare/beWinList.jspx',
      params: params
    })
  },
  getBargainList(params) {
    return http({
      method: 'post',
      url: '/product/bargain/batch/list.jspx',
      params: params
    })
  },
  submitAssess(params){
    return http({
      method: 'post',
      url: 'assess/result/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitDeclare(params){
    return http({
      method: 'post',
      url: 'product/declare/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitPerformance(params){
    return http({
      method: 'post',
      url: 'performance/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitCredential(params){
    return http({
      method: 'post',
      url: 'declare/credential/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitWinPrice(params){
    return http({
      method: 'post',
      url: 'product/declare/winprice/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitReoffer(params){
    return http({
      method: 'post',
      url: 'product/declare/reoffer/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitOfferform(params){
    return http({
      method: 'post',
      url: 'declare/offer/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  declareResultRemove(params){
    return http({
      method: 'post',
      url: 'declare/result/remove.jspx',
      data: Qs.stringify(params)
    });
  },
  getPerformance(params){
    return http({
      method: 'post',
      url: 'performance/get.jspx',
      data: Qs.stringify(params)
    });
  },
  submitApply(params){
    return http({
      method: 'post',
      url: 'declare/result/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  removeDeclare(params){
    return http({
      method: 'post',
      url: 'product/declare/remove.jspx',
      data: Qs.stringify(params)
    });
  },
  submitAssessPwd(params){
    return http({
      method: 'post',
      url: 'member/assess/password.jspx',
      data: Qs.stringify(params)
    });
  },
  getMember(params) {
    return http({
      method: 'get',
      url: '/member/user_account.jspx',
      params: params
    })
  },
  getAccount(params){
    return http({
      method: 'get',
      url: '/member/account_info.jspx',
      params: params
    })
  },
  updateTalent(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: '/member/updateTalent.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  updatePassword(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: '/member/pwd.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  updateDelegate(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: '/member/updateDelegate.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  deleteContact(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: '/member/deleteContact.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  submitContact(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: '/member/addContact.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  submitBiddingform(params){
    return http({
      method: 'post',
      url: 'member/bidding/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  getUserAttachmemts(params){
    return http({
      method: 'post',
      url: 'member/getUserAttachmemts.jspx',
      data: Qs.stringify(params)
    });
  },
  getVaccineProduct(params){
    return http({
      method: 'post',
      url: '/vaccine/product/get.jspx',
      data: Qs.stringify(params)
    });
  },
  submitTenders(params){
    return http({
      method: 'post',
      url: 'declare/tenders/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  removeTenders(params){
    return http({
      method: 'post',
      url: 'declare/tenders/remove.jspx',
      data: Qs.stringify(params)
    });
  },
  submitTendersFile(params){
    return http({
      method: 'post',
      url: 'declare/tenders/update.jspx',
      data: Qs.stringify(params)
    });
  },
  guestbookCtgList(params){
    return http({
      method: 'post',
      url: '/business/gbctg/list.jspx',
      params: params
    })
  },
  saveGuestbook(params){
    return http({
      method: 'post',
      url: '/business/guestbook/save.jspx',
      params: params
    })
  },
  guestbookPage(params){
    return http({
      method: 'post',
      url: '/business/guestbook/page.jspx',
      params: params
    })
  },
  businessQAPage(params){
    return http({
      method: 'post',
      url: '/business/qa_page.jspx',
      params: params
    })
  },
};
export default  memberApi;



// WEBPACK FOOTER //
// ./src/api/member/index.js